import React, { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { changePassword } from '../../../services/auth';
import { extractErrorMessage } from '../../../utils/apiError';

/**
 * PART 3, раздел 7: существующий password flow и ничего больше. Фиктивных
 * security-действий без API здесь быть не должно.
 */
const ProfileSecurityTab = () => {
  const [form, setForm] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' });
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);
  const [saving, setSaving] = useState(false);

  const onChange = (event) => {
    const { name, value } = event.target;
    setForm((prev) => ({ ...prev, [name]: value }));
    if (error) setError('');
    if (done) setDone(false);
  };

  const onSubmit = (event) => {
    event.preventDefault();

    if (form.newPassword.length < 8) {
      setError('Новый пароль должен быть не короче 8 символов');
      return;
    }
    if (form.newPassword !== form.confirmPassword) {
      setError('Новые пароли не совпадают');
      return;
    }

    setSaving(true);
    changePassword(form.oldPassword, form.newPassword)
      .then(() => {
        setError('');
        setDone(true);
        setForm({ oldPassword: '', newPassword: '', confirmPassword: '' });
      })
      .catch((requestError) => setError(extractErrorMessage(requestError, 'Не удалось изменить пароль')))
      .finally(() => setSaving(false));
  };

  return (
    <div className="pp-card">
      <h2 className="pp-card-title">Смена пароля</h2>

      <Form onSubmit={onSubmit} className="pp-form">
        <Form.Group className="mb-2">
          <Form.Label>Старый пароль</Form.Label>
          <Form.Control
            type="password"
            name="oldPassword"
            value={form.oldPassword}
            onChange={onChange}
            required
          />
        </Form.Group>

        <Form.Group className="mb-2">
          <Form.Label>Новый пароль</Form.Label>
          <Form.Control
            type="password"
            name="newPassword"
            value={form.newPassword}
            onChange={onChange}
            minLength={8}
            required
          />
        </Form.Group>

        <Form.Group className="mb-2">
          <Form.Label>Подтвердите новый пароль</Form.Label>
          <Form.Control
            type="password"
            name="confirmPassword"
            value={form.confirmPassword}
            onChange={onChange}
            minLength={8}
            required
          />
        </Form.Group>

        {error && <div className="pp-password-error">{error}</div>}
        {done && <div className="pp-success">Пароль изменён</div>}

        <Button variant="primary" type="submit" disabled={saving}>
          {saving ? 'Сохранение…' : 'Изменить пароль'}
        </Button>
      </Form>
    </div>
  );
};

export default ProfileSecurityTab;
